(function() {
	'use strict';

	angular.module('smb-app')
		.constant('smbIconTypes', {
			JPEG: 0,
			GIF: 1,
			PNG: 2,
			ICO: 3,
			SVG: 4,
			0: 'JPEG',
			1: 'GIF',
			2: 'PNG',
			3: 'ICO',
			4: 'SVG'
		})
		.factory('smbIconService', ['$http', 'pxUriPathService', 'smbIconTypes', IconService]);

	function IconService($http, pxUriPathService, smbIconTypes) {

		var _binaryTypes = [
			smbIconTypes[smbIconTypes.JPEG],
			smbIconTypes[smbIconTypes.GIF],
			smbIconTypes[smbIconTypes.PNG],
			smbIconTypes[smbIconTypes.ICO]
		];

		return {

			getIcons: getIcons,
			getIconData: getIconData

		};

		function getIcons() {
			return $http.get(pxUriPathService.resolvePath('/systemicons/SMB'))
				.then(function(res) { return res.data; });
		}

		function getIconData(url, type) {
			var request = {
				method: 'GET',
				url: url,
				headers: {
					Accept: getMediaType(type)
				},
				cache: true
			};

			if (isBinary(type)) {
				request.responseType = 'arraybuffer';
			}

			return $http(request)
				.then(function(res) { 
					return {
						imageData: res.data,
						isBinary: isBinary(type),
						contentType: res.headers('Content-Type')
					};
				});
		}

		function getMediaType(type) {
			var mediaType = 'image/';

			switch (type) {
				case smbIconTypes[smbIconTypes.JPEG]:
					return mediaType + 'jpeg';
				case smbIconTypes[smbIconTypes.GIF]:
					return mediaType + 'gif';
				case smbIconTypes[smbIconTypes.PNG]:
					return mediaType + 'png';
				case smbIconTypes[smbIconTypes.ICO]:
					return mediaType + 'ico';
				case smbIconTypes[smbIconTypes.SVG]:
					return mediaType + 'svg+xml';
				default:
					throw new Error('Unsupported data type for smbIcon');
			}
		}

		function isBinary(type) {
			return _binaryTypes.indexOf(type) >= 0;
		}

	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/services/iconService.js
// module id = 153
// module chunks = 1